import React from "react";
import { getSpacingClassName } from "@qlik/qlik/src/lib/util/spacing";
import Cta from "@qlik/qlik/src/components/Cta";
import { getColorClassName } from "@qlik/qlik/src/lib/util/colors";

/**
 * CardDarkBackground component
 * This component renders a card with a dark background.
 * @param {Object} data - The data for the card.
 */
const CardDarkBackground = ({ data }) => {
    const { title, additionalConfiguration, backgroundColor, cardItems = [], customId } = data ?? {};
    // Get the padding class name based on the additional configuration
    const sectionSpacingClassName = getSpacingClassName(additionalConfiguration, "pt-22 pb-10.25");

    // Get the color class name based on the background color
    const { sectionColorMapping } = getColorClassName(backgroundColor);

    // Get the length of the card items
    const cardLength = cardItems?.length;

    return (
        // Render a section with the appropriate padding and background color
        <section className={`${sectionSpacingClassName} ${sectionColorMapping.bgColor}`} id={customId}>
            <div className="container">
                {/* Render the title if it exists */}
                {title && <h2 className={`text-center ${sectionColorMapping.primaryTextColor}`}>{title}</h2>}
                {/* Render the card items if they exist */}
                {cardItems && (
                    <div className={`row mt-12.5 lg:mt-[94px] ${cardLength >= 4 ? "" : "xl:gap-7.5"}`}>
                        {cardItems?.map((item) => (
                            <div
                                key={item.id}
                                className={`col-12 mb-10.25 px-7.5 lg:col-6 ${cardLength >= 4 ? "xl:col-3" : "xl:col"}`}
                            >
                                {/* Render the item title if it exists */}
                                {item?.title && (
                                    <h3 className={`title-4 mb-3.75 ${sectionColorMapping.primaryTextColor}`}>
                                        {item?.title}
                                    </h3>
                                )}
                                {/* Render the item description if it exists */}
                                {item?.description?.description && (
                                    <p className={`mb-3.75 lg:mb-7.5 ${sectionColorMapping.primaryTextColor}`}>
                                        {item?.description?.description}
                                    </p>
                                )}
                                {/* Render the item CTA if it exists */}
                                {item?.cta && (
                                    <div className="flex flex-col gap-3.75">
                                        {item?.cta?.map((button) => (
                                            <Cta key={button.id} data={button} />
                                        ))}
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </section>
    );
};

// Export the CardDarkBackground component
export default CardDarkBackground;
